import {
    CircleXIcon,
    HandCoins,
    Handshake,
    TimeIcon
} from "../../icons";

// Interface para resumo de assinaturas
interface SubscriptionSummary {
    totalSubscriptions: number;
    activeSubscriptions: number;
    canceledSubscriptions: number;
    pausedSubscriptions: number;
    /** ciclo venceu e o pagamento nao entrou (o backend chama de past_due) */
    pastDueSubscriptions: number;
    mrrEstimated: number; // Monthly Recurring Revenue
}

interface SubscriptionsMetricsProps {
    summary?: SubscriptionSummary;
    isLoading?: boolean;
}

export default function SubscriptionsMetrics({ summary, isLoading = false }: SubscriptionsMetricsProps) {
    // Formatação de valor monetário
    const formatCurrency = (value: number) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(value);
    };

    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-6">
            {/* <!-- Metric Item Start --> */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                        <Handshake className="text-gray-800 size-6 dark:text-white/90" />
                    </div>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Assinaturas ativas
                    </span>
                </div>
                <div className="flex items-end justify-between mt-4">
                    <div>
                        <h4 className="mt-2 me-1 font-bold text-gray-800 text-xl dark:text-white/90 whitespace-nowrap">
                            {isLoading ? (
                                <div className="h-7 w-16 bg-gray-200 animate-pulse rounded dark:bg-gray-700"></div>
                            ) : (
                                summary?.activeSubscriptions || 0
                            )}
                        </h4>
                    </div>
                </div>
            </div>
            {/* <!-- Metric Item End --> */}

            {/* <!-- Metric Item Start --> */}
            {/*
              RENOVAÇÃO PENDENTE (past_due no backend)

              Este card não existia. O resumo mostrava só ativas e canceladas, e
              quem estava em past_due entrava no total sem aparecer em lugar
              nenhum: o produtor somava os cards, não fechava com o total e
              concluía que faltavam assinaturas.
            */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                        <TimeIcon className="text-gray-800 size-6 dark:text-white/90" />
                    </div>
                    <span
                        className="text-sm text-gray-500 dark:text-gray-400"
                        title="O ciclo venceu e o pagamento não entrou: cobrança recusada, ou PIX/boleto, que só renova se o cliente pagar de novo."
                    >
                        Renovação pendente
                    </span>
                </div>
                <div className="flex items-end justify-between mt-4">
                    <div>
                        <h4 className="mt-2 me-1 font-bold text-gray-800 text-xl dark:text-white/90 whitespace-nowrap">
                            {isLoading ? (
                                <div className="h-7 w-16 bg-gray-200 animate-pulse rounded dark:bg-gray-700"></div>
                            ) : (
                                summary?.pastDueSubscriptions || 0
                            )}
                        </h4>
                    </div>
                </div>
            </div>
            {/* <!-- Metric Item End --> */}

            {/* <!-- Metric Item Start --> */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                        <CircleXIcon className="text-gray-800 size-6 dark:text-white/90" />
                    </div>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        Assinaturas canceladas
                    </span>
                </div>
                <div className="flex items-end justify-between mt-4">
                    <div>
                        <h4 className="mt-2 me-1 font-bold text-gray-800 text-xl dark:text-white/90 whitespace-nowrap">
                            {isLoading ? (
                                <div className="h-7 w-16 bg-gray-200 animate-pulse rounded dark:bg-gray-700"></div>
                            ) : (
                                summary?.canceledSubscriptions || 0
                            )}
                        </h4>
                    </div>
                </div>
            </div>
            {/* <!-- Metric Item End --> */}

            {/* <!-- Metric Item Start --> */}
            <div className="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] md:p-6">
                <div className="flex items-center gap-3">
                    <div className="flex items-center justify-center w-12 h-12 bg-gray-100 rounded-xl dark:bg-gray-800">
                        <HandCoins className="text-gray-800 size-6 dark:text-white/90" />
                    </div>
                    <span className="text-sm text-gray-500 dark:text-gray-400">
                        MRR
                    </span>
                </div>
                <div className="flex items-end justify-between mt-4">
                    <div>
                        <h4 className="mt-2 me-1 font-bold text-gray-800 text-xl dark:text-white/90 whitespace-nowrap">
                            {isLoading ? (
                                <div className="h-7 w-28 bg-gray-200 animate-pulse rounded dark:bg-gray-700"></div>
                            ) : (
                                formatCurrency(summary?.mrrEstimated || 0)
                            )}
                        </h4>
                    </div>
                </div>
            </div>
            {/* <!-- Metric Item End --> */}
        </div>
    );
}